export const baseURL = process.env.REACT_APP_API_BASE_URL || "";
export const regionEnv = (process.env.REACT_APP_REGION || "").toUpperCase();
export const isPDFGenerationEnabled = process.env.REACT_APP_PDF_GENERATOR_ENABLED === 'true';

export enum REGIONS_NAME {
    LATAM = "LATAM",
    ROMANIA = "ROMANIA",
    USA = "USA",
}

export type RegionName = REGIONS_NAME.LATAM | REGIONS_NAME.ROMANIA | REGIONS_NAME.USA;

export const isRegion = {
    latam: regionEnv === REGIONS_NAME.LATAM,
    romania: regionEnv === REGIONS_NAME.ROMANIA,
    usa: regionEnv === REGIONS_NAME.USA,
};

export const EUR = "EUR";
export const CURRENCY = isRegion.latam || isRegion.usa ? "$" : isRegion.romania ? "€" : "";

export const availableYears: string[] = isRegion.latam
    ? ["2021", "2023"]
    : isRegion.usa ? ["2025"]
    : ["2018", "2019", "2020", "2021", "2022", "2023", "2024"];

export const defaultYear: string = availableYears[availableYears.length - 1];
